import { render } from "./TheHome.vue?vue&type=template&id=a937b9c2"
import script from "./TheHome.vue?vue&type=script&lang=js"
export * from "./TheHome.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ofmartinez/WebDev/orbeas/Holton-OrbeasRogue-Web-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__